export var URL;
(function (URL) {
    URL["API_URL"] = "/api";
    URL["AUTH_URL"] = "/api/auth";
    URL["STANDINGS_URL"] = "/api/standings";
    URL["VERIFICATION_URL"] = "/api/verification";
})(URL || (URL = {}));
